interface DocumentRowLike {
    id: string;
    financialDocument?: { id: number };
}

interface UpdateDocumentRowByIdParams<TRow extends DocumentRowLike> {
    rows: TRow[];
    id: string;
    update: Partial<Omit<TRow, "id">>;
}

export function updateDocumentRowById<TRow extends DocumentRowLike>({
    rows,
    id,
    update,
}: UpdateDocumentRowByIdParams<TRow>): TRow[] {
    const financialDocumentId = update.financialDocument?.id;
    const isTrackedByAnotherRow =
        financialDocumentId !== undefined &&
        rows.some(
            (row) =>
                row.id !== id &&
                row.financialDocument?.id === financialDocumentId,
        );
    if (isTrackedByAnotherRow) {
        return rows.filter((row) => row.id !== id);
    }
    return rows.map((row) => (row.id === id ? { ...row, ...update } : row));
}
